module.exports = __webpack_public_path__ + "media/images/ico-mic-no-013eb286.svg";